import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

const SharedURL = ({ str, name }: { str: string; name: any }) => {
  const currentUrl = window.location.href + "game/" + name;
  const { t } = useTranslation();

  return (
    <CopyToClipboard text={currentUrl}>
      <div>{t(str)}</div>
    </CopyToClipboard>
  );
};

export default SharedURL;
